export interface NotificationSettings {
  enabled: boolean;
  autoDismiss: boolean;
  durationSeconds: number;
  showUnreadBadge: boolean;
  showDashboardWidget: boolean;
  updatedAt: string | null;
}

export type UpdateNotificationSettingsPayload = Omit<
  NotificationSettings,
  'updatedAt'
>;

export interface NotificationSettingsResponse {
  ok: true;
  data: NotificationSettings;
}

export const DEFAULT_NOTIFICATION_SETTINGS: NotificationSettings = {
  enabled: true,
  autoDismiss: true,
  durationSeconds: 8,
  showUnreadBadge: true,
  showDashboardWidget: true,
  updatedAt: null,
};
